import React, { type RefObject, forwardRef, createContext } from 'react';
import { useFelaEnhanced } from '@ackee/fela';

import { useIntersectionObserver } from 'hooks';
import { useWindowSize } from 'utils/hooks';

import { useBackgroundPixelation } from './hooks';
import { BackgroundMode } from './constants';

import * as felaRules from './PixelatedBackgroundWrapper.rules';

export interface PixelatedBackgroundWrapperProps {
    children: React.ReactNode;
}

export const PixelatedBackgroundContext = createContext<BackgroundMode>(BackgroundMode.Light);

export const PixelatedBackgroundWrapper = forwardRef<HTMLElement, PixelatedBackgroundWrapperProps>(
    ({ children }, darkModeElementRef) => {
        const { width: windowWidth } = useWindowSize();

        const isDarkModeElementOnScreen = useIntersectionObserver(darkModeElementRef as RefObject<HTMLElement>, {
            threshold: windowWidth < 1024 ? 0.3 : 0.6,
        });

        const { backgroundCSS, backgroundMode } = useBackgroundPixelation(isDarkModeElementOnScreen);

        const { styles } = useFelaEnhanced(felaRules, { backgroundCSS, backgroundMode });

        return (
            <PixelatedBackgroundContext.Provider value={backgroundMode}>
                <div className={styles.container}>{children}</div>
            </PixelatedBackgroundContext.Provider>
        );
    },
);
